import { useQuery } from "@tanstack/react-query";

import { CACHE_DURATIONS } from "src/utils/constants";

import axios from 'src/lib/axios';
import { FEATURE_FLAGS } from "src/global-config";

import type { AllBucketResponse, S3IntegrationParams } from "../../../types/s3";

const getAllS3BucketList = async (params: S3IntegrationParams) => {
  const response = await axios.get('/api/storage/list', { params });
  return response.data;
};

export const useGetAllBucketsS3 = (params: S3IntegrationParams) => {
  const { data, isLoading, error } = useQuery<AllBucketResponse>({
    queryKey: ['s3-integration', params],
    queryFn: () => getAllS3BucketList(params),
    enabled:FEATURE_FLAGS.enableS3Integration === 'true',
    staleTime: CACHE_DURATIONS.MEDIUM
  });

  return {
    bucketList: data,
    isLoadingBucketLIst: isLoading,
    error,
  };
};